import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";
import Editor from "./NetworkEditor";
import service from "./NetworkService";

export default {
  mixins: [AppLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.companyName;
    }
  }
};
